import { memo } from "react";
import { ListItem } from "./ListItem";

export const ListItemMemo = memo<typeof ListItem>(ListItem);

ListItemMemo.displayName = "ListItemMemo";
